import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Slide, { SlideProps } from "@mui/material/Slide";
type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}

interface props {
  message: string;
}

export default function SucessSnackBar({ message }: props) {
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const [open, setOpen] = useState(false);
  //console.log("message", message)

  useEffect(() => {
    if (message) {
      setOpen(true);
      setTransition(() => TransitionUp);
      setTimeout(() => {
        setOpen(false);
      }, 3000);
    }
  }, [message]);

  // console.log(message)
  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={transition}
        sx={{ marginTop: "60px", zIndex: 9999 }}
      >
        <div style={{ background: "#54BF00", borderRadius: "10px " }}>
          <div style={{ marginLeft: "30px" }}>
            <Alert
              icon={false}
              severity="success"
              sx={{
                width: { xs: "90%", sm: "max-content" },
                height: { xs: "max-content", sm: "50px" },
                fontSize: "16px",
                borderRadius: "0",
                display: "flex",
                alignItems: "center",
                background: "#EAFFE9",
                flexWrap: "wrap",
              }}
            >
              {message}
            </Alert>
          </div>
        </div>
      </Snackbar>
    </div>
  );
}
